// Server
// const baseURL = 'http://thesfb.live/Autohub_Backend/api';
const baseURL = 'https://k-tech.store/Autohub_Backend/api';

// artisan serve: no /Autohub_Backend prefix
// const baseURL = 'http://127.0.0.1:8000/api';

// Apache/XAMPP:
// const baseURL = 'http://localhost/Autohub_Backend/api';
// const baseURL = 'http://192.168.18.86/Autohub_Backend/api';

export default baseURL;
